import { Box, Button, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';

import VNPortlet from '@/components/VNPortlet/VNPortlet';
import VnModalBody from '@/modals/components/VnModalBody';
import VnModalFooter from '@/modals/components/VnModalFooter';
import useAppUtils from '@/utils/appUtils';
import clientUtils from '@/utils/clientUtils';

type Props = {
  cssUrl: string;
  logoUrl: string;
};

const OneBillSnippet = ({ cssUrl, logoUrl }: Props) => {
  const [tab, setTab] = useState(0);
  const [contentText, setContentText] = useState('');
  const { alert } = useAppUtils();

  const generateSelfCareScript = () => {
    return `
<script>
(function () {
  const CSS_URL = "${cssUrl}";
  const LOGO_URL = "${logoUrl}";

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CSS_URL;
  document.head.appendChild(link);

  document.documentElement.style.setProperty(
    "--onebill-logo-url",
    'url("' + LOGO_URL + '")'
  );
})();
</script>
`;
  };

  const generateShoppingCartCSS = () => {
    return `
@import url("${cssUrl}");

#business_logo {
  content: url("${logoUrl}") !important;
}
`;
  };

  const updateContent = () => {
    if (tab === 0) {
      setContentText(generateSelfCareScript());
    } else {
      setContentText(generateShoppingCartCSS());
    }
  };

  const copyContent = () => {
    clientUtils.copyToClipboard(contentText);
    alert('Copied successfully.');
  };

  useEffect(() => {
    updateContent();
  }, [tab, cssUrl, logoUrl]);

  return (
    <>
      <VnModalBody>
        <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} sx={{ mb: 2 }}>
          <Tab label="SelfCare Styles" />
          <Tab label="Shopping Cart Styles" />
        </Tabs>

        <VNPortlet>
          <Box
            sx={{
              width: '100%',
              p: 2,
              borderRadius: 1,
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              // backgroundColor: '#f5f5f5',
              minHeight: 200,
            }}
          >
            {contentText}
          </Box>
        </VNPortlet>
      </VnModalBody>

      <VnModalFooter
        right={
          <Button variant="contained" color="success" onClick={copyContent}>
            Copy
          </Button>
        }
      />
    </>
  );
};

export default OneBillSnippet;
